export default {

  methods: {

    set_LocalValues(){

      this.rawData = JSON.parse(JSON.stringify(this.DataItems[0]))
      let json = JSON.parse(JSON.stringify(this.JQueries))

      this.title    = json.title
      this.bar      = json.bar
      this.values   = json.values
      this.columns  = json.columns

      this.keys     = json.keys
      this.filters  = json.filters
      this.sundries = json.sundries

      

    






    },

  }
}